import React, { useRef, useEffect } from "react";
import Swiper from "swiper";

const MovieRef = ({ urls }) => {
  const swiperRef = useRef(null);

  useEffect(() => {
    if (urls.length > 0) {
      swiperRef.current = new Swiper(".swiper-container", {
        slidesPerView: "3",
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    }
  }, [urls]);

  return (
    <div className="movie-ref">
      <div className="movie-ref-container">
        <h2 className="movie-ref-title">Recommended Media</h2>
        <div className="swiper-ref-container movie-ref-content">
          <div className="swiper-ref-wrapper">
            {urls.map((item, index) => (
              <div className="swiper-slide" key={index}>
                <a
                  href={item.url}
                  target="_blank"
                  rel="noreferrer"
                  className="movie-ref-link"
                >
                  <img
                    className="movie-ref-image"
                    src={item.poster}
                    alt={item.rid}
                  />
                  <p className="movie-ref-rid">{item.rid}</p>
                </a>
              </div>
            ))}
          </div>
          <div className="swiper-button-next"></div>
          <div className="swiper-button-prev"></div>
        </div>
      </div>
    </div>
  );
};

export default MovieRef;
